import { apiSlice } from "./apiSlice";

export const RolesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchAllRole: builder.query({
      query: () => ({
        url: `/rbac/roles/fetchAll`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    })
  })
});

export const { useFetchAllRoleQuery, useLazyFetchAllRoleQuery } = RolesApiSlice;
